import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import DirectorProfileSection from './components/DirectorProfileSection';
import FooterSection from '../home/components/FooterSection';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const schemaOrg = {
  '@context': 'https://schema.org',
  '@type': 'ProfilePage',
  '@id': `${SITE_URL}/director-profile#webpage`,
  url: `${SITE_URL}/director-profile`,
  name: 'ディレクター経歴紹介｜株式会社Y\'s STUDIO',
  description: '株式会社Y\'s STUDIOのディレクター経歴・プロフィールをご紹介します。営業視点とWeb制作の実務経験を持つディレクターが成果につながるサイトを設計します。',
  inLanguage: 'ja',
  isPartOf: {
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    url: `${SITE_URL}/`,
    name: '株式会社Y\'s STUDIO',
  },
  about: {
    '@type': 'Person',
    name: 'Y\'s STUDIO ディレクター',
    jobTitle: 'Webディレクター',
    worksFor: {
      '@type': 'Organization',
      name: '株式会社Y\'s STUDIO',
      url: `${SITE_URL}/`,
    },
  },
};

export default function DirectorProfile() {
  useEffect(() => {
    window.scrollTo(0, 0);

    const id = 'schema-director-profile';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schemaOrg);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-16">
        <DirectorProfileSection />
      </div>
      <FooterSection />
    </div>
  );
}